import o from "./ghl-ui.es730.js";
var f = 1 / 0;
function n(r) {
  if (typeof r == "string" || o(r))
    return r;
  var t = r + "";
  return t == "0" && 1 / r == -f ? "-0" : t;
}
export {
  n as default
};
